/**
 * The per-tenant backend returns location currency symbols as HTML entities
 * (e.g. "&#8362;" for ₪). Decode numeric entities so the symbol can be used
 * in plain-text contexts (t() interpolation, button labels) and not only via
 * dangerouslySetInnerHTML.
 */
export const decodeHtmlEntities = (value?: string | null): string => {
  if (!value) return '';
  return value
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCodePoint(parseInt(hex, 16)))
    .replace(/&#(\d+);/g, (_, code) => String.fromCodePoint(Number(code)))
    .replace(/&amp;/g, '&');
};

interface LocationWithSymbol {
  symbol?: string | null;
}

/**
 * Currency symbol for a money amount in the booking flows.
 * getBookingCost responses carry no currency field, so the selected
 * location's symbol (from the getLocations call) is the reliable source;
 * "$" only remains as the last-resort fallback.
 */
export const getCurrencySymbol = (
  bookingCurrency?: string | null,
  location?: LocationWithSymbol | null,
  fallback = '$',
): string => {
  return decodeHtmlEntities(bookingCurrency) || decodeHtmlEntities(location?.symbol) || fallback;
};
